// config.js

const bizIcon = 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/f25a032a-b163-4e43-b677-b17d1c9333ca9086.png?alt=media&token=fbca7269-e6bb-4dda-aff7-8bba0c5bda28';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://media.istockphoto.com/id/470351458/photo/happy-male-worker-with-broom-cleaning-office-corridor.jpg?s=612x612&w=0&k=20&c=k8GXcTt5v4LyCdaXtBisYm3SS9XGeNpIc2NJ8o3idW0=";
const imageTwo = "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/10cbfb77-6824-4e33-b390-d63a2a868fbcb77a.jpg?alt=media&token=c40a6e7d-d971-4dc5-8485-fb2b3ad7e568";
const imageThree = "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/6620c2a6-d951-4ce0-81a8-808a9dfc9718564a.png?alt=media&token=b9cbf245-bdb9-470c-92a9-8129e4243d1a";
const imageFour = "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/15a6b363-f286-4d31-b455-c5eccb42d906e98f.jpg?alt=media&token=0023ac86-22bb-4a3f-a274-d0884858d0b5";
const imageFive = "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/e5d39d33-81f1-486d-a3d3-3930f25e3e1e5b81.jpg?alt=media&token=054e3693-97eb-46cb-a9ff-e180c48b4254";

const redirectLink = "https://everfreshandclean.com/";
export const siteConfig = {
  title: "Ever Fresh & Clean LLC",
  metaDescription: "Ever Fresh & Clean LLC",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-600"
  },
  logo: {
    src: bizIcon,
    alt: "Ever Fresh & Clean LLC",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Ever Fresh & Clean LLC",
    headline: "Expert In Cleaning Services in Parkville, MD",
    address: "Parkville, Maryland, United States",
    description: `
        Ever Fresh & Clean LLC is dedicated to providing top-notch cleaning services for residential and commercial properties in Parkville, MD. With a focus on attention to detail, eco-friendly products, and exceptional customer care, we ensure every space is spotless and inviting. From deep cleaning to routine maintenance, trust Ever Fresh & Clean LLC to keep your home or business fresh, clean, and healthy.`,
  },  
  images: {
    business: {
      src: imageOne,
      alt: "Expert In Cleaning Services in Parkville, MD",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Professional Cleaning Services: Transform your spaces with expert cleaning tailored for homes, offices, and construction sites. Ever Fresh & Clean LLC ensures every corner sparkles with attention to detail.",
    },
    {
        description: 
          "Eco-Friendly Solutions: We use environmentally friendly products to deliver a spotless clean while keeping your space safe and healthy for your family, employees, and clients.",
    },
    {
        description: 
          "Why Choose Us: With a commitment to exceptional service and customer satisfaction, Ever Fresh & Clean LLC goes above and beyond to create spotless and inviting environments that enhance your daily life or business operations.",
    },
  ],
  services: {
    sectionTitle: "Services",
    description: 
    "Ever Fresh & Clean LLC is proud to serve Parkville, MD, and the surrounding areas with professional cleaning services tailored to meet the needs of homes, offices, and construction sites. Whether you're looking for residential cleaning, post-construction cleanup, or maintaining a spotless office, we deliver exceptional results with attention to detail and customer satisfaction.",
    callouts: [
        {
          name: 'Residential Cleaning',
          description: 
          "Leave the dirty work to us! Our reliable residential cleaning service ensures your home is spotless and sparkling. Using high-quality products and meticulous attention to detail, we leave your home feeling fresh and inviting.",
          imageSrc: imageTwo,
          imageAlt: 'A clean and fresh residential living room in Parkville, MD',
        },
        {
          name: 'Post-Construction Cleaning',
          description: 
          "Experience top-notch post-construction cleaning services. Our skilled team removes all debris and dust left behind from construction, leaving your property spotless and ready to enjoy.",
          imageSrc: imageThree,
          imageAlt: 'A freshly cleaned post-construction site in Parkville, MD',
        },
        {
          name: 'Office Cleaning',
          description: 
          "Maintain a pristine and organized work environment with our efficient office cleaning services. We handle everything from dusting to sanitizing, allowing you to focus on your work in a clean and productive space.",
          imageSrc: imageFour,
          imageAlt: 'A professional office cleaned by Ever Fresh & Clean LLC in Parkville, MD',
        },
    ]
  },  
  about: {
    sectionTitle: "About",
    description:   
      "Welcome to Ever Fresh & Clean LLC! We are a family-owned and locally operated cleaning service dedicated to providing exceptional residential, post-construction, and office cleaning in Parkville, MD, and surrounding areas. With a focus on attention to detail and personalized care, we aim to create spotless and inviting environments for our clients. Whether it’s deep cleaning, organizing, or sanitization, our skilled team ensures every space is left refreshed and immaculate. Discover the difference of a reliable and professional cleaning experience with Ever Fresh & Clean LLC.",
    image: {
      src: imageFive,
      alt: "Ever Fresh & Clean LLC team performing professional cleaning services in Parkville, MD",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Parkville, MD",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.3212311348794!2d-76.57278838464785!3d39.37788597949786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c8033a9e22a7ab%3A0xabcdef123456789!2sParkville%2C%20MD%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Parkville,%20MD,%20USA&ll=39.377886,-76.572789&q=Parkville',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Parkville,+MD,+USA&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Parkville,+MD,+USA/@39.377886,-76.572789,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Parkville,+MD,+USA/@39.377886,-76.572789,15z',
      }
    ]
  },
  contact: {
    sectionTitle: "Ready to start? Book an appointment today.",
    description: "Contact Ever Fresh & Clean LLC today to schedule your cleaning service! Whether it’s residential cleaning, post-construction cleanup, or office cleaning, we’re here to transform your space into a spotless and inviting environment.",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (443) 704-4368",
    ],
    logo: bizIcon,
    emailRecipient: "everfreshcleanllc@gmail.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


